import * as Yup from 'yup'

import { FormikNotesArea } from "../../../../../components/widgets"
import { IWebFileAttachment } from '../../../../core/applications';

export interface IDLMPhasANote  {
  verdict: string, 
  workflow: string,
  appState: string,
  note: string,
  noteAttachments: Array<IWebFileAttachment>,    
}

export const initDLMPhasANoteValues: IDLMPhasANote = {
  verdict: '', 
  workflow: '',
  appState: '',
  note: '',
  noteAttachments: [],    
}

export const DLMPhasANoteSchema: any = Yup.object({
  verdict: Yup.string().trim(),    
  workflow: Yup.string().trim(),    
  appState: Yup.string().trim(),
  note: Yup.string().trim().required().label('Note'),    
  noteAttachments: Yup.array(),
});

export const DLMPhasANoteForm = () => {
  return (
  <FormikNotesArea required />
  )
}
